<template>
  <b-dropdown
    v-if="isButton || isIcon"
    position="is-bottom-left"
    aria-role="list"
    class="has-text-left">
      <a slot="trigger" :class="{ button: isButton }">
        <b-icon icon="map-marker" :style="{ color: color[type] }"></b-icon>
      </a>
      <b-dropdown-item custom>
        <compact class="qdColorPicker" v-model="color" :style="style"></compact>
      </b-dropdown-item>
  </b-dropdown>
  <compact v-else class="qdColorPicker" :style="style" v-model="color" :palette="palette"></compact>
</template>

<script>
import { Compact } from 'vue-color';

export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: 'hex',
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    isIcon: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 15,
    },
    palette: {
      type: Array,
      default: null,
    },
  },
  components: {
    Compact,
  },
  computed: {
    color: {
      get() {
        return { [this.type]: this.value };
      },
      set(newValue) {
        this.$emit('input', newValue[this.type]);
      },
    },
    style() {
      return {
        '--size': `${this.size}px`,
        width: `${12 * this.size + 65}px`,
        'box-shadow': 'none !important',
      };
    },
  },
};
</script>

<style lang="scss">
.qdColorPicker {
& .vc-compact-color-item {
  width: var(--size, 15px);
  height: var(--size, 15px);
}
}
</style>
